<template>
    <Panel class="rounded-md border text-sm relative">
        <div
            v-if="review.locked_auth"
            class="bg-white opacity-90 absolute top-0 left-0 w-full h-full z-10 flex items-center justify-center">
            <div>
                <h4 class="font-medium mb-4">Unlock more reviews by creating a free account</h4>

                <div class="text-center">
                    <Link :href="route('register')" class="button-primary">Create an Account</Link>
                </div>
            </div>

        </div>


        <div
            v-if="review.locked_founder_review_limit"
            class="bg-white opacity-90 absolute top-0 left-0 w-full h-full z-10 flex items-center justify-center">
            <div>
                <h4 class="font-medium mb-4">Unlock all reviews by posting a review</h4>

                <div class="text-center">
                    <Link :href="route('reviews.create')" class="button-primary">Post a Review</Link>
                </div>
            </div>

        </div>


        <div class=" p-4 space-y-3 flex flex-col justify-between h-full">
            <div>
                <div v-if="showInvestor && review.investor">
                    <div class="flex items-center justify-between mb-2">
                        <Link :href="route('investors.show', review.investor)" class="flex items-center">
                            <img
                                :src="review.investor.profile_photo_url"
                                class="w-7 h-7 rounded-[100px] object-cover mr-2">
                            <div class="text-zinc-800 text-sm font-medium leading-tight flex items-center">
                                <span class="mr-1">{{ review.investor.name }}</span>
                                <svg
                                    fill="none" height="24" viewBox="0 0 24 24" width="24"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20 12C19.9847 11.45 19.8169 10.9144 19.5147 10.4538C19.2133 9.99404 18.7893 9.62622 18.2903 9.39293C18.4802 8.87612 18.5202 8.31673 18.4095 7.77778C18.298 7.23797 18.0375 6.74074 17.6586 6.34142C17.2584 5.96254 16.762 5.70285 16.2222 5.59046C15.6833 5.47978 15.1239 5.5198 14.6071 5.70966C14.3746 5.20988 14.0077 4.78501 13.547 4.48361C13.0864 4.18221 12.5509 4.01362 12 4C11.45 4.01447 10.9161 4.18135 10.4564 4.48361C9.99659 4.78587 9.63133 5.21073 9.4006 5.70966C8.88293 5.5198 8.32184 5.47808 7.78118 5.59046C7.24053 5.70115 6.74244 5.96169 6.34227 6.34142C5.96339 6.74159 5.70456 7.23968 5.59472 7.77863C5.48404 8.31758 5.52661 8.87697 5.71733 9.39293C5.21754 9.62622 4.79183 9.99319 4.48872 10.453C4.18561 10.9127 4.01618 11.4491 4 12C4.01703 12.5509 4.18561 13.0864 4.48872 13.547C4.79183 14.0068 5.21754 14.3746 5.71733 14.6071C5.52661 15.123 5.48404 15.6824 5.59472 16.2214C5.70541 16.7612 5.96339 17.2584 6.34142 17.6586C6.74159 18.0358 7.23882 18.2946 7.77778 18.4061C8.31673 18.5185 8.87612 18.4776 9.39293 18.2903C9.62622 18.7893 9.99319 19.2133 10.4538 19.5155C10.9136 19.8169 11.45 19.9847 12 20C12.5509 19.9864 13.0864 19.8186 13.547 19.5172C14.0077 19.2158 14.3746 18.7901 14.6071 18.2912C15.1213 18.4947 15.685 18.5432 16.2273 18.4308C16.7688 18.3184 17.2661 18.0502 17.6577 17.6586C18.0494 17.2669 18.3184 16.7697 18.4308 16.2273C18.5432 15.685 18.4947 15.1213 18.2903 14.6071C18.7893 14.3738 19.2133 14.0068 19.5155 13.5462C19.8169 13.0864 19.9847 12.55 20 12ZM10.8608 15.278L7.94125 12.3593L9.04215 11.2507L10.8063 13.0149L14.5526 8.93316L15.6994 9.99404L10.8608 15.278Z"
                                        fill="#333333"/>
                                </svg>

                            </div>
                        </Link>


                        <div class="flex">
                            <Link
                                :href="route('reviews.create', review.investor)"
                                class=" h-7 pl-2 pr-3 py-1.5 bg-white rounded-full border border-gray-200 justify-start items-center gap-1 inline-flex">
                                <svg
                                    class="w-4 h-4 relative" fill="none" height="16" viewBox="0 0 16 16" width="16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8 3.83334V12.1667" stroke="#828F9B" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="1.5"/>
                                    <path
                                        d="M12.1667 8H3.83333" stroke="#828F9B" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="1.5"/>
                                </svg>


                                <div class="text-zinc-800 text-xs font-medium leading-3">Add Review</div>
                            </Link>
                        </div>
                    </div>
                    <HeadingLineThrough>REVIEW</HeadingLineThrough>
                </div>
                <div class="flex items-center justify-between mb-1">
                    <div class="flex items-center">

                        <div class="flex items-center">
                            <div class="pr-2 pt-1 text-zinc-800 font-medium text-sm">{{ review.star_rating }}</div>

                            <ReadonlyRating :rating="review.star_rating" size="small"/>

                            <Menu as="div" class="relative inline-block text-left">
                                <div>
                                    <MenuButton
                                        class="z-0 mt-2 inline-flex w-full justify-center rounded-md  bg-white  text-sm font-medium text-gray-700  hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                        <svg
                                            fill="none" height="24" viewBox="0 0 24 24" width="24"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M15.25 10.75L12 14.25L8.75 10.75" stroke="#A0A5BE"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                        </svg>

                                    </MenuButton>
                                </div>

                                <transition
                                    enter-active-class="transition ease-out duration-100"
                                    enter-from-class="transform opacity-0 scale-95"
                                    enter-to-class="transform opacity-100 scale-100"
                                    leave-active-class="transition ease-in duration-75"
                                    leave-from-class="transform opacity-100 scale-100"
                                    leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems
                                        class="absolute right-0 z-10 mt-2 w-60 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div
                                            v-for="(rating, index) in review.star_ratings" :key="'rating-' + index"
                                            class="px-4 py-3 flex items-center">
                                            <ReadonlyRating
                                                :rating="rating.score" class="pr-2"
                                                size="small"/>
                                            <p class=" text-sm  text-gray-900" v-text="rating.label"/>
                                        </div>


                                    </MenuItems>
                                </transition>
                            </Menu>
                        </div>
                    </div>
                    <div>
                        <div v-if="review.verified" class="flex items-center text-gray-500">
                            <CheckCircleIcon class="w-4 h-4 mr-1 text-blue-500"/>
                            <div class="font-medium text-xs">Verified</div>
                        </div>
                        <div v-if="review.new" class="flex items-center text-gray-500">
                            <PlusCircleIcon class="w-4 h-4 mr-1 text-green-500"/>
                            <div class="font-medium text-xs">New</div>
                        </div>
                    </div>
                </div>


                <div>
                    <div class="mb-4 text-gray-400 text-sm font-normal leading-tight">
                        {{ review.content }}
                    </div>


                    <div class="mb-3 flex items-center space-x-2">
                        <RaisedLabel v-if="review.portfolio_member">
                            <svg
                                fill="none" height="16" viewBox="0 0 16 16" width="16"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4.5 8.57692L6.35294 10.5L11.5 5.5" stroke="#5BC083" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="1.5"/>
                            </svg>
                            Raised money from {{ review.investor.name }}
                        </RaisedLabel>


                        <RaisedLabel v-else>

                            <svg
                                fill="none" height="16" viewBox="0 0 16 16" width="16"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.5 4.5L4.5 11.5" stroke="#F04438" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"/>
                                <path
                                    d="M4.5 4.5L11.5 11.5" stroke="#F04438" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"/>
                            </svg>


                            Didn't raise money from {{ review.investor.name }}
                        </RaisedLabel>


                        <div
                            class=" h-6 px-2 bg-zinc-500 bg-opacity-10 rounded-[999px] justify-center items-center inline-flex">
                            <div class="text-zinc-800 text-opacity-60 text-xs font-medium leading-none">{{ review.round
                                }}
                            </div>
                        </div>

                    </div>
                </div>


            </div>


            <div class="flex justify-between items-center">
                <div class="flex items-center text-gray-400  text-xs font-medium leading-[14px]">
                    <ClockIcon class="w-4 h-4 mr-1"/>
                    <div>
                        {{ review.timeframe }}
                    </div>
                </div>


                <Link
                    v-if="showInvestor && review.investor" :href="route('investors.show', review.investor)"
                    class="text-gray-400 text-xs font-medium leading-[14px] flex items-center">
                    <span class="mr-1">Read more {{ review.investor.name }} reviews</span>
                    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.16666 5.83333L9.49999 7.99999L7.16666 10.1667" stroke="#828F9B" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="1.5"/>
                    </svg>
                </Link>

            </div>

        </div>

        <div v-if="canReply" class="p-4 border-t">
            <div class="font-medium mb-2">Reply to the Founder</div>
            <div>
                <form @submit.prevent="reply">
                    <Textarea v-model="replyForm.content" class="mb-3"/>
                    <div class="flex items-center">
                        <Button :disabled="replyForm.processing" class="mr-2" type="submit">Save</Button>

                        <div v-if="replyForm.recentlySuccessful" class="text-sm">
                            Reply saved!
                        </div>
                    </div>
                </form>
            </div>
        </div>


        <div v-if="review.reply && !canReply" class="p-4 border-t">
            <div class="font-medium mb-2">Reply from Investor</div>
            <div>
                {{ review.reply }}
            </div>
        </div>
    </Panel>
</template>
<script>
import ReadonlyRating from '@/Components/Legacy/ReadonlyRating.vue';
import {ClockIcon, CheckCircleIcon, PlusCircleIcon} from '@heroicons/vue/24/outline/esm/index.js';
import {Menu, MenuButton, MenuItems} from '@headlessui/vue';
import {ChevronDownIcon} from '@heroicons/vue/20/solid/esm/index.js';
import {Link} from '@inertiajs/vue3';
import Textarea from '@/Components/Legacy/Textarea.vue';
import Button from '@/Components/Legacy/Jetstream/Button.vue';
import Panel from '@/Components/Legacy/2023/Panel.vue';
import HeadingLineThrough from '@/Components/Legacy/2023/HeadingLineThrough.vue';
import RaisedLabel from '@/Components/Legacy/2023/RaisedLabel.vue';

export default {
    components: {
        RaisedLabel,
        HeadingLineThrough,
        Panel,
        Button,
        Textarea,
        ReadonlyRating,
        ClockIcon,
        CheckCircleIcon,
        PlusCircleIcon,
        Menu,
        MenuButton,
        MenuItems,
        ChevronDownIcon,
        Link,
    },
    props: {
        review: {
            type: Object,
            required: true,
        },

        canReply: {
            type: Boolean,
            default: false,
        },

        showInvestor: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            replyForm: this.$inertia.form({
                content: this.review.reply ?? ''
            })
        };
    },

    methods: {
        reply() {
            this.replyForm.post(this.route('reviews.reply', {review: this.review.uuid}), {preserveScroll: true});
        }
    }
};
</script>
